import { Text, View, StyleSheet, Image, Font, Svg, Path } from '@react-pdf/renderer'
import React from 'react'
import LatoRegular from '../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import Pointer from "../../Assets/Images/pointer.png"
import bar from "../../Assets/Images/bar.png"
import Fixed from "../../Assets/Images/Fixed.png"
import Growth from "../../Assets/Images/Growth.png"
import indicator from "../../Assets/Images/indicator.png"
import LatoItalic from "../../Assets/Fonts/Lato-Font/Lato-Italic.ttf"

const MindSetPage3 = ({ apidata }) => {

    const percentage = 54;

    Font.register({
        family: 'Lato',
        fonts: [
            { src: LatoRegular, fontWeight: 400 },
            { src: LatoBold, fontWeight: 700 },
            { src: LatoItalic, fontStyle: 'italic' }
        ]
    });

    const getLeftPosition = (percentage) => {
        if (percentage >= 0 && percentage <= 16) {
            return "70px"; 
        } else if (percentage >= 17 && percentage <= 40) {
            return "158px"; 
        } else if (percentage >= 41 && percentage <= 64) {
            return "242px"; 
        } else if (percentage >= 65 && percentage <= 88) {
            return "325px";
        } else {
            return "410px";
        }
    };

    const getActiveCategory = (percentage) => {
        if (percentage >= 0 && percentage <= 16) {
            return "rigid";
        } else if (percentage >= 17 && percentage <= 40) {
            return "cautious";
        } else if (percentage >= 41 && percentage <= 64) {
            return "conditional";
        } else if (percentage >= 65 && percentage <= 88) {
            return "adaptive";
        } else {
            return "transformative";
        }
    };

    const activeCategory = getActiveCategory(percentage);

    const styles = StyleSheet.create({
        header: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: "#5795B2",
            borderBottom: "1px solid #5795B2"
        },
        title: {
            width: "183px",
            fontSize: "14px",
            fontFamily: "Lato",
            lineHeight: "18px",
            color: "#5795B2",
            fontWeight: 400,

        },
        titlebold: {
            fontWeight: 700
        },
        details: {
            fontSize: "10px",
            fontFamily: "Lato",
            lineHeight: "16px",
            color: "#5795B2",
            fontWeight: 400,
            width: "73px",
            textAlign: "right"

        },
        textbold: {
            fontWeight: 700
        },
        content: {
            marginTop: "30px",
            display: "flex",
            justifyContent: "center",
            width: "570px",
            alignItems: "center"
        },
        footer: {
            position: "absolute",
            bottom: "0px",
            borderTop: "1px solid #426B88",
            display: "flex",
            flexDirection: "row",
            width: "571px",
            gap: "30px"
        },
        pagewapper: {
            position: "relative",
            height: "100%"
        },
        footertitle: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            textTransform: "uppercase",
            marginTop: "10px"
        },
        description: {
            color: "#76A3BE",
            fontFamily: "Lato",
            fontWeight: 400,
            fontSize: "8px",
            lineHeight: "18px",
            width: "496px"

        },
        pagenumber: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            marginTop: "10px"
        },
        titleImage: {
            width: "251px",
            height: "58px",
            marginTop: "40px"
        },
        compareImage: {
            width: "533px",
            height: "401px",
            marginTop: "15px"
        },
        contentTitle: {
            textTransform: "uppercase",
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "21px",
            color: "#426B88",
        },
        tooltip: {
            width: "509px",
            height: "116px",
            backgroundColor: "#EAF1F5",
            borderRadius: "5px",
            paddingTop: "10px",
            paddingHorizontal: "7px",
            position: "relative",
            marginTop: "20px"
        },
        tooltipcontent: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            fontFamily: "Lato",
            fontSize: "11.73px",
            lineHeight: "20.2px",
            color: "#5E5E5E",
            gap: "5px",
            marginVertical: "2px"
        },
        dot: {
            width: "5px",
            height: "5px",
            backgroundColor: "#5E5E5E",
            borderRadius: "100px",
            marginBottom: "6px"
        },
        bulletpoint: {
            display: "flex",
            flexDirection: "row"
        },
        bulletpointTitle: {
            fontWeight: 700
        },
        image: {
            width: "19px",
            height: "19px",
            position: "absolute",
            top: "-15px",
            left: getLeftPosition(percentage),
        },
        category: {
            width: "501px",
            height: "96px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20px",
            position: "relative"

        },
        bar: {
            width: "412px",
            height: "20px",
        },
        fixed: {
            width: "39px",
            height: "39px"
        },
        growth: {
            width: "40px",
            height: "40px"
        },
        fixedtext: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "11.73px",
            lineHeight: "20.2px",
            color: "#5E5E5E"
        },
        growthtext: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "11.73px",
            lineHeight: "20.2px",
            color: "#246C21"
        },
        fixedwapper: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "7px",
            marginBottom: "30px",
            marginRight: "10px"
        },
        growthwapper: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "7px",
            marginBottom: "30px",
            marginLeft: "80px",

        },
        percentage: {
            minWidth: "51.49px",
            height: "32.59px",
            backgroundColor: "#245775",
            position: "absolute",
            top: "-45px",
            borderRadius: "5.21px",
            left: `calc(${percentage}%)`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
        },
        pertext: {
            color: "#FFFFFF",
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "20.86px",
            lineHeight: "22.81px",
            marginTop: "2px"
        },
        indicator: {
            bottom: "-10px"
        },
        barwrapper: {
            position: "relative",
            top: "6px",
        },
        bartextwapper: {
            display: "flex",
            flexDirection: "row",
            marginTop: "8px",
            gap: "10px",
            position: "absolute",
            top: "20px"
        },
        bartext: {
            fontFamily: "Lato",
            fontWeight: 400,
            fontSize: "11px",
            lineHeight: "11.2px",
            color: "#5E5E5E",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            width: "74px",
            textAlign: "center"
        },
        active: {
            fontWeight: 700
        },
        resultContent: {
            width: "570px",
            fontFamily: "Lato",
            fontSize: "12px",
            lineHeight: "18px",
            color: "#245775",
            marginTop: "10px"
        },
        resultTitle: {
            fontWeight: 700
        },
        resultText: {
            fontWeight: 400
        },
        resultText2: {
            fontWeight: 400,
            marginTop: "20px"
        },
        credit: {
            fontFamily: "Lato",
            fontWeight: 400,
            marginTop: "18px",
            fontSize: "10px",
            lineHeight: "18px",
            color: "#5795B2",
            fontStyle: "italic"
        }
    });
    return (
        <View style={styles.pagewapper}>
            <View style={styles.header}>
                <View style={styles.title}>
                    <Text style={styles.titlebold}>Quadrant Flow</Text>
                    <Text>Life & Leadership Assessment</Text>
                </View>
                <View style={styles.details}>
                    <Text style={styles.textbold}>Rob Murray</Text>
                    <Text>Atlas Real Estate</Text>
                    <Text>Oct 18, 2024</Text>
                </View>
            </View>
            <View style={styles.content}>
                <Text style={styles.contentTitle}>Your Mindset results</Text>
                <View style={styles.category}>
                    <View style={styles.fixedwapper}>
                        <Image src={Fixed} style={styles.fixed} />
                        <Text style={styles.fixedtext}>Fixed</Text>
                    </View>

                    <View style={styles.barwrapper}>
                        <View style={styles.percentage}>
                            <Text style={styles.pertext}>{percentage}%</Text>
                            {/* <Image src={indicator} style={styles.indicator} /> */}
                            <Svg width="17" height="15" viewBox="0 0 17 15" style={[styles.indicator, { transform: 'rotate(180deg)' }]}>
                                <Path d="M8.5 0L16.7272 14.25H0.272758L8.5 0Z" fill="#00577D" />
                            </Svg>
                        </View>
                        <Image src={bar} style={styles.bar} />
                        <View style={styles.bartextwapper}>
                            <View style={styles.bartext}>
                                <Text style={activeCategory === "rigid" ? styles.active : null}>Rigid</Text>
                                <Text style={activeCategory === "rigid" ? styles.active : null}>Self-Definition</Text>
                            </View>
                            <View style={styles.bartext}>
                                <Text style={activeCategory === "cautious" ? styles.active : null}>Cautious</Text>
                                <Text style={activeCategory === "cautious" ? styles.active : null}>Openness</Text>
                            </View>
                            <View style={styles.bartext}>
                                <Text style={activeCategory === "conditional" ? styles.active : null}>Conditional</Text>
                                <Text style={activeCategory === "conditional" ? styles.active : null}>Growth</Text>
                            </View>
                            <View style={styles.bartext}>
                                <Text style={activeCategory === "adaptive" ? styles.active : null}>Adaptive</Text>
                                <Text style={activeCategory === "adaptive" ? styles.active : null}>Learner</Text>
                            </View>
                            <View style={styles.bartext}>
                                <Text style={activeCategory === "transformative" ? styles.active : null}>Transformative</Text>
                                <Text style={activeCategory === "transformative" ? styles.active : null}>Growth</Text>
                            </View>

                        </View>
                    </View>


                    <View style={styles.growthwapper}>
                        <Image src={Growth} style={styles.growth} />
                        <Text style={styles.growthtext}>Growth</Text>
                    </View>

                </View>
                <View style={styles.tooltip}>
                    {/* <Image src={Pointer} style={styles.image} /> */}

                    <Svg width="17" height="15" viewBox="0 0 17 15" style={styles.image}  >
                        <Path d="M8.5 0L16.7272 14.25H0.272758L8.5 0Z" fill="#EAF1F5" />
                    </Svg>

                    <View style={styles.tooltipcontent}>
                        <View style={styles.dot} />
                        <View style={styles.bulletpoint}>
                            <Text style={styles.bulletpointTitle}>Belief:</Text>
                            <Text> “My abilities can grow with effort and strategies.”</Text>
                        </View>

                    </View>
                    <View style={styles.tooltipcontent}>
                        <View style={styles.dot} />
                        <View style={styles.bulletpoint}>
                            <Text style={styles.bulletpointTitle}>Focus:</Text>
                            <Text>Seeks diverse challenges for development, even at the risk of failure.</Text>
                        </View>

                    </View>
                    <View style={styles.tooltipcontent}>
                        <View style={styles.dot} />
                        <View style={styles.bulletpoint}>
                            <Text style={styles.bulletpointTitle}>Response to Feedback:</Text>
                            <Text>Welcomes feedback as a tool for improvement.</Text>
                        </View>

                    </View>
                    <View style={styles.tooltipcontent}>
                        <View style={styles.dot} />
                        <View style={styles.bulletpoint}>
                            <Text style={styles.bulletpointTitle}>View of Effort:</Text>
                            <Text>Effort is necessary and rewarding for growth.</Text>
                        </View>

                    </View>
                    <View style={styles.tooltipcontent}>
                        <View style={styles.dot} />
                        <View style={styles.bulletpoint}>
                            <Text style={styles.bulletpointTitle}>Reaction to Failure:</Text>
                            <Text>Views failure as an opportunity to learn and adapt.</Text>
                        </View>

                    </View>
                </View>
                <View style={styles.resultContent}>
                    <Text style={styles.resultTitle}>Your Results: Adaptive & Transformative</Text>
                    <Text style={styles.resultText}>
                        Your results indicate that you embody a growth mindset, aligning with the Adaptive Learner and Transformative Growth levels. This mindset reflects your belief that abilities and intelligence can be developed through effort, learning, and persistence. It’s a powerful perspective that turns challenges into opportunities and views setbacks as essential steps toward mastery.
                    </Text>
                    <Text style={styles.resultText2}>
                        With a growth mindset, you actively embrace challenges and seek out opportunities to improve, welcoming feedback as a valuable tool for growth. You recognize effort as a pathway to progress and are not discouraged by setbacks, using them as lessons to refine your approach and build resilience.
                        This mindset also positively impacts those around you. By valuing collaboration and viewing others’ successes as sources of inspiration rather than competition, you foster supportive and innovative environments. Your ability to integrate learning and persistence contributes to stronger relationships, teamwork, and leadership.
                    </Text>
                    <Text style={styles.resultText2}>
                        Your commitment to continuous improvement sets the foundation for personal and professional success. By maintaining this perspective, you are well-equipped to navigate challenges, achieve meaningful growth, and inspire others to do the same. Keep leveraging this mindset to unlock even greater potential in yourself and those you influence.
                    </Text>

                </View>
            </View>
            <View style={styles.credit}>
                <Text>*Credit: Healthy Growing Leaders</Text>
            </View>
            <View style={styles.footer}>
                <View>
                    <Text style={styles.footertitle}>SELF Report</Text>
                    <Text style={styles.description}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
                </View>
                <View style={styles.pagenumber}>
                    <Text>PAGE</Text>
                </View>

            </View>

        </View>

    )
}

export default MindSetPage3